class VideoCard extends HTMLElement {
  protected container: HTMLElement | null = null;
  protected button: HTMLElement | null = null;
  protected video: HTMLVideoElement | null = null;
  protected videoTitle: HTMLElement | null = null;

  connectedCallback() {
    this.container = this.querySelector(':scope > *');
    this.button = this.querySelector('[data-play]');
    this.video = this.querySelector('video');
    this.videoTitle = this.querySelector('.js-video-overlay');

    if (!this.button || !this.video) return;

    this.button.addEventListener('click', this.handleClickVideo.bind(this));
    this.video.addEventListener('pause', this.handlePausedVideo.bind(this));
  }

  handleClickVideo() {
    if (!this.video) return;

    this.scrollVideoIntoView();

    // Control video play state
    if (this.video.paused) {
      window.pauseAllMedia();
      this.container?.setAttribute('data-playing', 'true');
      this.videoTitle?.classList.add('hidden');
      this.video.play();
    } else {
      window.pauseAllMedia();
    }
  }

  handlePausedVideo() {
    if (!this.video) return;
    this.container?.removeAttribute('data-playing');
    this.videoTitle?.classList.remove('hidden');
  }

  scrollVideoIntoView() {
    // Scroll video to view before playing
    // can be configured as data-scroll-* attribute
    const scrollOptions = ['nearest', 'center'];
    const scrollBlock = this.getAttr(
      this.button?.getAttribute('data-scroll-block') ?? null,
      scrollOptions,
    ) as ScrollLogicalPosition;
    const scrollInline = this.getAttr(
      this.button?.getAttribute('data-scroll-inline') ?? null,
      scrollOptions,
    ) as ScrollLogicalPosition;

    this.video?.scrollIntoView({ behavior: 'smooth', block: scrollBlock, inline: scrollInline });
  }

  getAttr(value: string | null, options: string[], defaultValue?: string) {
    if (value && options.includes(value)) return value;
    return defaultValue ?? options[0];
  }
}

if (!customElements.get('video-card')) {
  customElements.define('video-card', VideoCard);
}
